
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Users, Calendar, Mail } from "lucide-react";

const AdminMetricsOverview: React.FC = () => {
  // Sample data - in a real app this would come from an API
  const metricsData = [
    {
      title: "Total Operators",
      value: "32",
      change: "+4% from last month",
      trend: "up",
      icon: <Users className="h-5 w-5 text-sauna-blue" />,
    },
    {
      title: "Active Listings",
      value: "28",
      change: "+12% from last month",
      trend: "up",
      icon: <BarChart className="h-5 w-5 text-sauna-green" />,
    },
    {
      title: "Monthly Visitors",
      value: "2,856",
      change: "+23% from last month",
      trend: "up",
      icon: <Calendar className="h-5 w-5 text-sauna-orange" />,
    },
    {
      title: "Support Requests",
      value: "8",
      change: "-2 from last week",
      trend: "down",
      icon: <Mail className="h-5 w-5 text-sauna-navy" />,
    },
  ];

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Overview Statistics</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {metricsData.map((item, i) => (
          <Card key={i} className="border border-gray-200 hover:shadow-md transition-shadow duration-200">
            <CardContent className="p-6">
              <div className="flex justify-between items-center">
                <div className="bg-gray-100 p-3 rounded-full">
                  {item.icon}
                </div>
                <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                  item.trend === "up" 
                    ? "bg-green-100 text-green-800" 
                    : "bg-red-100 text-red-800"
                }`}>
                  {item.change}
                </span>
              </div>
              <div className="mt-3">
                <h3 className="text-sm font-medium text-gray-500">{item.title}</h3>
                <p className="text-2xl font-bold mt-1">{item.value}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default AdminMetricsOverview;
